/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { classNames, classNameBindings } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { filter } from '@ember/object/computed';
import Component from '@ember/component';
import { isNone, isBlank } from '@ember/utils';
import LayoutModel from 'cio/models/layout';
import TemplateModel from 'cio/models/template';
import DS from 'ember-data';
import { dropTask } from 'ember-concurrency';
import { EmailPreview, RequestHeader } from 'cio/utils/previews';
import isDestroyed from 'cio/utils/is-destroyed';

@classNames('action-composer-panel', 'action-composer-panel--previewer', 'action-composer-panel--email')
@classNameBindings('template.layout:has-selected-layout', 'isChoosingLayout')
export default class Previewer extends Component {
  @service store!: DS.Store;

  isChoosingLayout!: boolean;
  selectedLayout!: LayoutModel;
  template!: TemplateModel;
  preview?: EmailPreview;
  onDiscard!: () => unknown;
  onLayoutClicked!: () => unknown;
  onOpenLayouts!: () => unknown;
  onSave!: () => unknown;
  hasReadOnlyPermission!: boolean;

  // internal
  layouts: LayoutModel[] = [];
  templateLayout?: LayoutModel;
  isViewingMobile = false;
  isHeaderPanelExpanded = false;

  fetchLayouts = dropTask(async () => {
    let activeLayouts = await this.store.query('layout', { archived: false });
    let layouts = activeLayouts.toArray();

    let layout = await this.getTemplateLayout.perform();

    // A user can delete a layout from another route and come back to this route. In that case,
    // we need to ensure that the layout isn't destroyed before pushing it to the array.
    if (!isNone(layout) && !layout.isDestroyed) {
      layouts.addObject(layout);
    }

    this.set('layouts', layouts);
  });

  getTemplateLayout = dropTask(async () => {
    // this.template can be already destroying when switching environments
    // test: http://127.0.0.1:4200/tests?testId=833e4871
    if (isDestroyed(this.template)) {
      return;
    }

    let layout = await this.template.belongsTo('layout').load();

    // A user can delete a layout from another route and come back to this route. In that case,
    // we need to ensure that the layout isn't destroyed before pushing it to the array.
    if (!isNone(layout) && !layout.isDestroyed) {
      this.set('templateLayout', layout);
    }

    return layout;
  });

  @computed('validHeaders', 'preview.reply_to', 'preview.bcc')
  get headerCount() {
    let count = this.validHeaders.length || 0;

    if (this.preview?.reply_to) {
      count++;
    }
    if (this.preview?.bcc) {
      count++;
    }

    return count;
  }

  @filter('preview.headers.@each.name', (header: RequestHeader) => !isBlank(header.name))
  validHeaders!: RequestHeader[];

  @action
  toggleViewingMobile(isShowing: boolean) {
    this.set('isViewingMobile', isShowing);
  }

  @action
  toggleHeaderPanel() {
    this.toggleProperty('isHeaderPanelExpanded');
  }
}
